export default __webpack_public_path__ + "static/media/cup.1fb6817a.svg";